module.exports = __webpack_public_path__ + "static/media/body_0.9f00e4b6.png";